module.exports = __webpack_public_path__ + "img/level_icon.362c3da9.png";